import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {MarkdownGroup, MarkdownLoaderService} from '../../services/markdown-loader.service';

@Component({
  selector: 'cc-markdown-list',
  templateUrl: './markdown-list.component.html',
  styleUrls: ['./markdown-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkdownListComponent implements OnInit {
  groups: Map<string, MarkdownGroup>;

  constructor(private readonly markdownLoaderService: MarkdownLoaderService) {
  }

  ngOnInit() {
    this.groups = this.markdownLoaderService.getGroups();
  }
}
